import { createStore, applyMiddleware, Reducer, Store } from "redux";
import { routerMiddleware } from "connected-react-router";
import createSagaMiddleware from "redux-saga";
import { createBrowserHistory } from "history";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";

import rootReducer from "../reducers";
import rootSaga from "../sagas";

const sagaMiddleware = createSagaMiddleware({
  context: {},
});

export const history = createBrowserHistory();

const createMainStore = composeWithDevTools(applyMiddleware(sagaMiddleware, routerMiddleware(history)))(createStore);

export default function configureStore(initialState: Reducer): Store {
  const store = createMainStore(rootReducer(history), initialState);
  sagaMiddleware.run(rootSaga);

  return store;
}
